import React from "react";
import MainContainer from "../../components/MainContainer";
import {Link} from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";

const ConfirmationPageGov = () => {
  const { authUser } = useAuth();

  return (
    <MainContainer>
      <div className="col-lg-8">
        <h1 className="mb-4">Επισκόπηση των στοιχείων σας</h1>
        <p>
          Επιβεβαιώστε ότι τα παρακάτω στοιχεία, με τα οποία έχετε συνδεθεί,
          είναι σωστά.
        </p>
        <dl className="row datalist my-5 mx-0">
          <dt className="col-sm-4">Όνομα</dt>
          <dd className="col-sm-8">{authUser?.firstname}</dd>
          <dt className="col-sm-4">Επώνυμο</dt>
          <dd className="col-sm-8">{authUser?.lastname}</dd>
          <dt className="col-sm-4">Α.Φ.Μ.</dt>
          <dd className="col-sm-8">{authUser?.taxid}</dd>
        </dl>
        <Link
          to={
            "/tickets-gov/suspended-users"
          }
          className="btn btn-primary btn-lg btn-login"
        >
	        {"Συνέχεια"}
        </Link>
      </div>
    </MainContainer>
  );
};

export default ConfirmationPageGov;
